import React from "react";
import ReferenceListContent from "./ReferenceListContent";
import Div from "../../components/common/Div";
import { Typography } from "@mui/material";

export default function ReferenceList(props) {
  return (
    <Div>
      {/* <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          color: "#fbcd02",
          padding: "5px",
          textAlign: "left",
          marginBottom: "5px",
        }}
      >
        Resources
      </Typography> */}
      <ReferenceListContent user={props.user} />
    </Div>
  );
}
